import React from "react";
import Translate from "../../../common/functions/translate";
import TextField from "@material-ui/core/TextField";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Units } from '../../../common/enums';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { FileModel } from '../../../models/fileModel';
import AuthService from "../../../services/authService";
import { OfferSteps } from '../../../common/enums';
import PlannerDialog from './plannerDialog';
import { newPlannerProject2Layers } from '../../../common/constants';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import Link from '@material-ui/core/Link';
//import { faMapMarked, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
//import { Button } from "@material-ui/core";
import IconButton from '../../../common/components/iconButton/iconButtonComponent';

let downloadPDF = (pdf: FileModel) => {
  if (pdf) {
    const linkSource = `data:application/pdf;base64,${pdf.fileContent}`;
    const downloadLink = document.createElement("a");
    downloadLink.setAttribute('href', linkSource);
    downloadLink.download = pdf.fileName + '.pdf';
    downloadLink.click();
  }
}

let downloadExcel = (excel: FileModel) => {
  if (excel) {
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excel.fileContent}`;
    const downloadLink = document.createElement("a");
    downloadLink.setAttribute('href', linkSource);
    downloadLink.download = excel.fileName + '.xlsx';
    downloadLink.click();
  }
}

let getTotalAmountByInstallation = (installation) => {
  let totalAmount = 0;
  if (installation.products && installation.products.length > 0)
    totalAmount += installation.products.reduce((acc, curr) => acc + (curr.quantity * curr.price), 0);

  if (installation.additionalProducts && installation.additionalProducts.length > 0)
    totalAmount += installation.additionalProducts.reduce((acc, curr) => acc + (curr.quantity * curr.price), 0);

  return totalAmount;
}

let checkDates = (firstDate, secondDate) => {
  if (firstDate && secondDate)
    return new Date(firstDate).getTime() !== new Date(secondDate).getTime();
  return true;
}

const GenerateOfferComponent = (props: any) => {
  const [isOpen, open] = React.useState(false);
  const [isAxonometric, setAxonometric] = React.useState(false);
  const [catalogType, setCatalogType] = React.useState(OfferSteps.GasInstallation);
  let authService = new AuthService();
  let additionalProducts = Array<any>();

  let planner = props.planner;
  if (!planner)
    planner = JSON.parse(JSON.stringify(newPlannerProject2Layers));

  let setOpen = (isAxonometric) => {
    setAxonometric(isAxonometric);
    open(true);
  }

  let toggleDialog = (isVis, isSaved) => {
    open(isVis);
    props.fullSave(isSaved);
  }

  //console.log(props.offerData);
  let gasInstallPrice = getTotalAmountByInstallation(props.offerData.gasInstallation);
  let heathInstallPrice = getTotalAmountByInstallation(props.offerData.heathInstall);
  if (props.offerData.gasInstallation.additionalProducts?.length > 0) {
    additionalProducts = [...additionalProducts, ...props.offerData.gasInstallation.additionalProducts];
  }

  if (props.offerData.heathInstall.additionalProducts?.length > 0) {
    additionalProducts = [...additionalProducts, ...props.offerData.heathInstall.additionalProducts];
  }

  let totalAmount = 0;
  if (props.offerData && props.offerData.gasInstallation && props.offerData.gasInstallation.products) {
    totalAmount += HelperFunctions.calculateProductsPrice(props.offerData.gasInstallation.products);
  }

  if (props.offerData && props.offerData.heathInstall && props.offerData.heathInstall.products) {
    totalAmount += HelperFunctions.calculateProductsPrice(props.offerData.heathInstall.products);
  }

  if (additionalProducts.length > 0) {
    totalAmount += HelperFunctions.calculateProductsPrice(additionalProducts);
  }

  let priceAfterDiscount = props.offerData.discount ? totalAmount - (totalAmount * props.offerData.discount / 100) : totalAmount;
  priceAfterDiscount = props.offerData.fixedDiscount ? priceAfterDiscount - props.offerData.fixedDiscount : priceAfterDiscount;
  let discountAmount = 0;

  if (props.offerData.discount || props.offerData.fixedDiscount) {
    discountAmount = totalAmount - priceAfterDiscount;
  }

  let vatPrice = priceAfterDiscount * 0.2;

  const tableSection = (rows, sectionName, props) => {
    return (
      <>
        <TableRow>
          <TableCell align="left" colSpan={5}>
            <strong>{Translate(sectionName)}</strong>
          </TableCell>
        </TableRow>
        {rows.map((row, index) => (
          <TableRow key={index + sectionName}>
            <TableCell component="th" scope="row">
              {row.articleNumber}
            </TableCell>
            <TableCell>{row.article}</TableCell>
            <TableCell align="right">{HelperFunctions.getEnumLabel(row.unitId, Units, true)}</TableCell>
            <TableCell align="right">{row.quantity}</TableCell>
            <TableCell align="right">{(row.price * row.quantity).toFixed(2) + " " + Translate('BGN')}</TableCell>
          </TableRow>
        ))}
      </>
    )
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Paper className="profile-card" style={{ marginBottom: "20px", padding: "20px", marginRight: "15px", maxWidth: "400px" }}>
          <div>
            <div className="profile-card-item">
              <div>
                {Translate('Number')}: <strong>{props.offerData.offerNumber}</strong>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: 'row', alignItems: "flex-start" }}>
            <div style={{ minWidth: "150px", marginRight: "30px" }}>
              <div className="profile-card-item" style={{ borderBottom: "1px solid #aaa" }}>
                <div>
                  <strong>{Translate('Client')}</strong>
                </div>
              </div>
              <div className="profile-card-item">
                <div>
                  {Translate('Name')}:
                </div>
                <div>
                  <strong>{props.offerData.clientData?.name}</strong>
                </div>
              </div>
              <div className="profile-card-item">
                <div>
                  {Translate('Email')}:
                </div>
                <div>
                  <strong>{props.offerData.clientData?.email}</strong>
                </div>
              </div>
              <div className="profile-card-item">
                <div>
                  {Translate('Phone')}:
                </div>
                <div>
                  <strong>{props.offerData.clientData?.phone}</strong>
                </div>
              </div>
            </div>

            <div style={{ minWidth: "150px", marginRight: "5px" }}>
              <div className="profile-card-item" style={{ borderBottom: "1px solid #aaa" }}>
                <div>
                  <strong>{Translate('Address')}</strong>
                </div>
              </div>
              <div className="profile-card-item">
                <div>
                  {Translate('Disctrict')}:
                </div>
                <div>
                  <strong>{props.offerData.clientData?.disctrict}</strong>
                </div>
              </div>
              <div className="profile-card-item">
                <div>
                  {Translate('Town')}:
                </div>
                <div>
                  <strong>{props.offerData.clientData?.town}</strong>
                </div>
              </div>
              <div className="profile-card-item">
                <div>
                  {Translate('Address')}:
                </div>
                <div>
                  <strong>{props.offerData.clientData?.address}</strong>
                </div>
              </div>
            </div>
          </div>
          {/* <div>
            {props.offerData.clientData?.latitude || props.offerData.clientData?.longitude
              ? <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                <Link href={`https://maps.google.com/?q=${props.offerData.clientData.latitude},${props.offerData.clientData.longitude}`}
                  target="_blank"
                  style={{ marginLeft: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <FontAwesomeIcon icon={faMapMarked} style={{ fontSize: "30px", marginRight: "5px" }} />
                    <span style={{ marginTop: 10 }}>{props.offerData.clientData.latitude}, {props.offerData.clientData.longitude}</span>
                  </div>
                </Link>
                <div style={{ marginLeft: 5, marginTop: 7, cursor: 'pointer' }} onClick={props.removeLocation}>
                  <FontAwesomeIcon icon={faTrashAlt} color={'#f50057'} size="lg" />
                </div>

              </div>
              : <div style={{ marginTop: 5 }}><Button
                onClick={props.getLocation}
                color="primary"
                variant="contained"
                size="small">
                {Translate('Get location')}
              </Button></div>}
          </div> */}
        </Paper>

        <Paper className="profile-card" style={{ marginBottom: "20px", padding: "20px", marginRight: "20px", maxWidth: "610px" }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={!props.offerData.equipmentOnly ? { width: '50%' } : {}}>
              {props.offerData.offerPdf ?
                <IconButton downloadClick={() => downloadPDF(props.offerData.offerPdf)}
                  icon={HelperFunctions.getIconByFileType("pdf")}
                  name={Translate("Offer")}
                  size={HelperFunctions.formatBytes(props.offerData.offerPdf.fileSizeInBytes, 0)}
                  type={"PDF"}
                  withoutGenerate={true}
                  canDownload
                  canSendMail
                  sendMailClick={props.sendEmailClick}
                />
                : null}
              {/* billOfQuantitiesExcel */}
              {props.offerData.billOfQuantitiesExcel ?
                <IconButton downloadClick={() => downloadExcel(props.offerData.billOfQuantitiesExcel)}
                  icon={HelperFunctions.getIconByFileType("xlsx")}
                  name={Translate('Bill of quantities')}
                  size={HelperFunctions.formatBytes(props.offerData.billOfQuantitiesExcel.fileSizeInBytes, 0)}
                  type={"EXCEL"}
                  canDownload
                  withoutGenerate={true}
                /> : null}

              {/* billOfQuantitiesLaborExcel */}
              {props.offerData.billOfQuantitiesLaborExcel ?
                <IconButton downloadClick={() => downloadExcel(props.offerData.billOfQuantitiesLaborExcel)}
                  icon={HelperFunctions.getIconByFileType("xlsx")}
                  name={Translate('Bill of quantities labor')}
                  size={HelperFunctions.formatBytes(props.offerData.billOfQuantitiesLaborExcel.fileSizeInBytes, 0)}
                  type={"EXCEL"}
                  canDownload
                  withoutGenerate={true}
                /> : null}
            </div>
            {!props.offerData.equipmentOnly
              ? <div style={{ width: '50%' }}>
                {/* installationPdf */}
                {props.offerData.installationPdf || (!props.offerData.installationPdf &&
                  (props.offerData.gasInstallation?.axonometryPdf || props.offerData.heathInstall?.axonometryPdf)) ?
                  <IconButton downloadClick={() => downloadPDF(props.offerData.installationPdf)}
                    icon={HelperFunctions.getIconByFileType("pdf")}
                    name={Translate("Installation")}
                    size={props.offerData.installationPdf ?
                      HelperFunctions.formatBytes(props.offerData.installationPdf.fileSizeInBytes, 0) : 0}
                    type={"PDF"}
                    withoutGenerate={props.offerData.installationPdf}
                    generate={() => setOpen(false)}
                    withSynch
                    synchCondition={props.offerData.installationPdf && checkDates(props.offerData.updatedOn, props.offerData.installationPdf.updatedOn)}
                    onSyncClick={() => setOpen(false)}
                    minWidth
                    canDownload={props.offerData.installationPdf}
                  /> : null}
                {/*gasInstallaxonometry */}
                {props.offerData.gasInstallation?.axonometryPdf || (!props.offerData.gasInstallation?.axonometryPdf &&
                  (props.offerData.installationPdf || props.offerData.heathInstall?.axonometryPdf)) ?
                  <IconButton downloadClick={() => downloadPDF(props.offerData.gasInstallation?.axonometryPdf)}
                    icon={HelperFunctions.getIconByFileType("pdf")}
                    name={Translate("AxonometricSchemeG")}
                    size={props.offerData.gasInstallation?.axonometryPdf ?
                      HelperFunctions.formatBytes(props.offerData.gasInstallation.axonometryPdf.fileSizeInBytes, 0) : 0}
                    type={"PDF"}
                    withoutGenerate={props.offerData.gasInstallation?.axonometryPdf}
                    canDownload={props.offerData.gasInstallation?.axonometryPdf}
                    generate={() => {
                      setCatalogType(OfferSteps.GasInstallation);
                      setTimeout(() => {
                        setOpen(true);
                      });
                    }}
                    withSynch
                    minWidth
                    synchCondition={props.offerData.gasInstallation?.axonometryPdf &&
                      checkDates(props.offerData.updatedOn, props.offerData.gasInstallation?.axonometryPdf.updatedOn)}
                    onSyncClick={() => {
                      setCatalogType(OfferSteps.GasInstallation);
                      setTimeout(() => {
                        setOpen(true);
                      });
                    }}
                  /> : null}
                {/*heathInstallaxonometry */}
                {props.offerData.heathInstallCheck && (props.offerData.heathInstall?.axonometryPdf || (!props.offerData.heathInstall?.axonometryPdf &&
                  (props.offerData.installationPdf || props.offerData.gasInstallation?.axonometryPdf))) ?
                  <IconButton downloadClick={() => downloadPDF(props.offerData.heathInstall?.axonometryPdf)}
                    icon={HelperFunctions.getIconByFileType("pdf")}
                    name={Translate("AxonometricSchemeH")}
                    withoutGenerate={props.offerData.heathInstall?.axonometryPdf}
                    canDownload={props.offerData.heathInstall?.axonometryPdf}
                    withSynch
                    minWidth
                    type={"PDF"}
                    size={props.offerData.heathInstall?.axonometryPdf ?
                      HelperFunctions.formatBytes(props.offerData.heathInstall.axonometryPdf.fileSizeInBytes, 0) : 0}
                    generate={() => {
                      setCatalogType(OfferSteps.HeatingInstallation);
                      setTimeout(() => {
                        setOpen(true);
                      });
                    }}
                    synchCondition={props.offerData.heathInstall?.axonometryPdf &&
                      checkDates(props.offerData.updatedOn, props.offerData.heathInstall?.axonometryPdf.updatedOn)}
                    onSyncClick={() => {
                      setCatalogType(OfferSteps.HeatingInstallation);
                      setTimeout(() => {
                        setOpen(true);
                      });
                    }}
                  /> : null}
              </div>
              : null}

          </div>
        </Paper>
      </div>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 170 }}><strong>{Translate("Article number")}</strong></TableCell>
              <TableCell><strong>{Translate("Article")}</strong></TableCell>
              <TableCell style={{ width: 80 }} align="right"><strong>{Translate("UnitShort")}</strong></TableCell>
              <TableCell style={{ width: 80 }} align="right"><strong>{Translate("Qty")}</strong></TableCell>
              <TableCell style={{ width: 150 }} align="right"><strong>{Translate("Price without VAT")}</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {props.offerData.gasInstallation.products?.length > 0 ?
              tableSection(props.offerData.gasInstallation.products, "GasInstallation", props)
              : null}

            {props.offerData.gasInstallation.additionalProducts?.length > 0 ?
              tableSection(props.offerData.gasInstallation.additionalProducts, "Services and materials", props)
              : null}

            {props.offerData.heathInstallCheck && props.offerData.heathInstall.products?.length > 0 ?
              tableSection(props.offerData.heathInstall.products, "HeatingInstallation", props)
              : null}

            {props.offerData.heathInstallCheck && props.offerData.heathInstall.additionalProducts?.length > 0 ?
              tableSection(props.offerData.heathInstall.additionalProducts, "Services and materials", props)
              : null}

            {/* {additionalProducts.length > 0 ?
              tableSection(additionalProducts, "Services", props)
              : null} */}

            <TableRow>
              <TableCell colSpan={4} align="right">
                {props.offerData.gasInstallation.products?.length > 0 || props.offerData.gasInstallation.additionalProducts?.length > 0 ?
                  <div>{Translate("GasInstallPrice")}</div> : null}
                {props.offerData.heathInstallCheck &&
                  (props.offerData.heathInstall.products?.length > 0 || props.offerData.heathInstall.additionalProducts?.length > 0) ?
                  <div>{Translate("HeathInstallPrice")}</div> : null}
                <div style={{ marginTop: 10 }}>{Translate("Total without VAT")}</div>
                {props.offerData.discount || props.offerData.fixedDiscount
                  ? <div>{Translate('Discount amount without VAT')}</div>
                  : null}
                {props.offerData.discount || props.offerData.fixedDiscount
                  ? <div>{Translate("Total after discount")}</div>
                  : null}
                <div>{Translate("VAT")}</div>
              </TableCell>
              <TableCell align="right">
                {props.offerData.gasInstallation.products?.length > 0 || props.offerData.gasInstallation.additionalProducts?.length > 0 ?
                  <div>{gasInstallPrice.toFixed(2) + " " + Translate('BGN')}</div> : null}
                {props.offerData.heathInstallCheck &&
                  (props.offerData.heathInstall.products?.length > 0 || props.offerData.heathInstall.additionalProducts?.length > 0) ?
                  <div>{heathInstallPrice.toFixed(2) + " " + Translate('BGN')}</div> : null}
                <div style={{ marginTop: 10 }}>{totalAmount.toFixed(2) + " " + Translate('BGN')}</div>
                {props.offerData.discount || props.offerData.fixedDiscount
                  ? <div>{`${discountAmount.toFixed(2)} ${Translate('BGN')}`}</div>
                  : null}
                {props.offerData.discount || props.offerData.fixedDiscount
                  ? <div>{priceAfterDiscount.toFixed(2) + " " + Translate('BGN')}</div>
                  : null}
                <div>{vatPrice.toFixed(2) + " " + Translate('BGN')}</div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={4} align="right"><span style={{ fontWeight: 600 }}>{Translate("Total with VAT")}</span></TableCell>
              <TableCell align="right"><span style={{ fontWeight: 600 }}>{(vatPrice + priceAfterDiscount).toFixed(2) + " " + Translate('BGN')}</span></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Paper style={{ margin: '20px 0px', display: 'flex', flexDirection: 'row', justifyContent: "flex-end", padding: 15 }}>
        <div>
          <TextField
            name="fixedDiscount"
            type="number"
            label={Translate("Discount (BGN)")}
            disabled={!authService.checkIsRegionalManager() || props.readOnly}
            onChange={(e) => props.onOfferChange('fixedDiscount', e.target['value'])}
            value={props.offerData?.fixedDiscount || ""}
            style={{ marginBottom: 10, marginLeft: 10, width: 130 }}
          />
        </div>
        <div>
          <TextField
            name="discount"
            type="number"
            label={Translate("Discount")}
            disabled={!authService.checkIsRegionalManager() || props.readOnly}
            onChange={(e) => props.onOfferChange('discount', e.target['value'])}
            value={props.offerData?.discount || ""}
            style={{ marginBottom: 10, marginLeft: 10, width: 120 }}
          />
        </div>
      </Paper>
      <Paper style={{ margin: '20px 0px', display: 'flex', flexDirection: 'row', padding: 15 }}>
        <div style={{ width: '100%' }}>
          {/* <div style={{ fontSize: 12, color: '#a1a1a1' }}>{Translate("Disclaimer")}</div> */}
          <p>{props.offerData?.adminNotes ? props.offerData?.adminNotes : ''}</p>
          <TextField
            name="disclaimer"
            type="text"
            label={Translate("Disclaimer")}
            disabled={props.readOnly}
            multiline={true}
            onChange={(e) => props.onOfferChange('disclaimer', e.target['value'])}
            value={props.offerData?.disclaimer || ""}
            style={{ marginBottom: 10 }}
          />
        </div>
      </Paper>
      {
        isOpen ?
          <PlannerDialog
            isOpen={isOpen}
            toggle={toggleDialog}
            activeStepNumber={props.activeStepNumber}
            activeStep={HelperFunctions.getEnumLabel(catalogType, OfferSteps, true)}
            saveClick={props.saveClick}
            catalogType={catalogType}
            planner={planner}
            offer={props.offerData}
            copiedLayer={props.copiedLayer}
            isAxonometric={isAxonometric}
            onlyPan
          /> : null
      }
    </>
  )

}

export default GenerateOfferComponent;
